import { render } from "./WallMurals.vue?vue&type=template&id=2207a48c"
const script = {}

import exportComponent from "D:\\Programing Projects\\iplusinteriors.github.io\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__